import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { portalRoutes } from "../routes/portalRoutes";
//import "../scss/_navbar.scss";
//import "../scss/_buttons.scss";

type Logo = {
  src: string;
  alt: string;
};

export type NavLink = {
  label: string;
  onClick: () => void;
};

type NavAction = {
  icon: ReactNode;
  action: () => void;
};

type Props = {
  logo: Logo;
  links: NavLink[];
  actions?: NavAction[];
};

export const NavBar = (props: Props) => {
  const navigateTo = useNavigate();

  return (
    <div className="nav-bar">
      <div className="container">
        <div className="container-items">
          <div className="logo">
            <img src={props.logo.src} alt={props.logo.alt} onClick={() => navigateTo("/")} />
          </div>
          <div className="nav-items">
            {props.links.map((link) => (
              <a key={link.label} className="nav-item" onClick={link.onClick}>
                {link.label}
              </a>
            ))}
          </div>
        </div>

        <div className="actions">
          {props.actions?.map((action, index) => (
            <div className="action" key={index} onClick={action.action}>
              {action.icon}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
